"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Application error:", error);
  }, [error]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <h2 className="mb-4 text-xl font-semibold">문제가 발생했습니다</h2>
      <p className="mb-6 text-text-muted">
        일시적인 오류가 발생했습니다. 다시 시도해주세요.
      </p>
      <button
        onClick={reset}
        className="rounded-lg bg-text px-6 py-2 text-text-inverse hover:bg-text"
      >
        다시 시도
      </button>
    </div>
  );
}
